import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Modal as AntModal, Button as AntButton } from 'antd';
import { get, forEach } from 'lodash';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { ComponentsManager, actions, EntitiesManager } from '@comall-backend-builder/core';
import { DESIGN_PAGE_TYPES } from '../../constants/page-design';
import { ITemplate } from '../../interfaces';

interface pageTemplateSelectorProps {
    entity: Entity;
    type: keyof typeof DESIGN_PAGE_TYPES;
    name: string;
    onChange: (item: any, name: any) => void;
    onFieldChange: (item: any, name: any) => void;
    value: ITemplate;
}

interface pageTemplateSelectorStates {
    visible: boolean;
    updateCount: number;
}

/**
 * 新增页面时选择模板。
 * 页面分类属性决定了可选模板的范围(如：类型为专题的页面，只能选择专题类型的模板)。
 * 如果页面分类属性变化，需要重置页面的模板选择。
 */
class pageTemplateSelector extends React.Component<
    pageTemplateSelectorProps,
    pageTemplateSelectorStates
> {
    state = { visible: false, updateCount: 0 };
    entity = new (EntitiesManager.get('DesignTemplate'))({});

    toggleModalVisible = () => {
        const { visible } = this.state;
        this.setState({ visible: !this.state.visible });
        const paging = this.entity.paging;
        if (!visible && paging) {
            const type = get(this.props, 'type');
            this.entity.search({ type, ...paging });
        }
    };

    onSelected = (item: any) => {
        const { onChange, name } = this.props;
        onChange(item, name);
        this.toggleModalVisible();
    };

    renderSelectorList = () => {
        const type = get(this.props, 'type');
        const config = {
            entity: this.entity,
            loadFirstPage: true,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ['10', '15', '20'],
            },
            grid: { gutter: 16, column: 4 },
            type: 'page',
            renderItem: 'PageTemplateListItem',
            onSelected: this.onSelected,
            params: { type },
        };

        return React.createElement(ComponentsManager.get('DataList'), config);
    };

    renderButton = (isEdit: boolean, value: any, typeName: string) => {
        const type = get(this.props, 'type');
        if (isEdit) {
            if (type) {
                if (type === 'signIn') {
                    return <div>无</div>;
                }
                return (
                    <AntButton
                        type="link"
                        style={{ padding: 0 }}
                        className="span-link"
                        onClick={this.toggleModalVisible}
                    >
                        {value ? `${value.name}(${typeName})` : '点击选择模板'}
                    </AntButton>
                );
            } else {
                return <span className="template-name">请先选择类型</span>;
            }
        } else {
            return <span className="template-name">{value && value.name}</span>;
        }
    };

    componentWillReceiveProps(nextProps: any) {
        const nextType = get(nextProps, 'type', null);
        const thisType = get(this.props, 'type', null);

        if (thisType !== null && nextType !== thisType) {
            this.props.onFieldChange('template', null);
        }

        if (nextType === 'signIn' && this.state.updateCount <= 2) {
            const { onChange, name } = this.props;
            const { updateCount } = this.state;
            this.setState({ updateCount: updateCount + 1 }, () => onChange({}, name));
        }
    }

    render() {
        const { value, entity, type } = this.props;
        const isEdit = !get(entity, 'fields.id');
        const typeName = DESIGN_PAGE_TYPES[type];

        return (
            <div className="page-template-selector">
                {this.renderButton(isEdit, value, typeName)}
                <AntModal
                    title={`选择模板(${typeName})`}
                    onOk={this.toggleModalVisible}
                    onCancel={this.toggleModalVisible}
                    okText="确认"
                    cancelText="取消"
                    footer={null}
                    visible={this.state.visible}
                    width={900}
                >
                    {this.renderSelectorList()}
                </AntModal>
            </div>
        );
    }
}

let formComponentId: any = null;
export const PageTemplateSelector = connect(
    (state, props) => {
        let result = {};
        const entityId = get(props, 'entity.id');
        if (entityId) {
            //@ts-ignore
            forEach(state.components, (c, key) => {
                formComponentId = key;
                if (c.entityId === entityId) {
                    //@ts-ignore
                    result.type = c.fields.type;
                }
            });
        }
        return result;
    },
    (dispatch, props) => {
        return {
            onFieldChange: (name: string, status: any) => {
                dispatch(actions.formChangeAction(formComponentId, name, status));
            },
        };
    }
)(pageTemplateSelector);
